import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {

  return (
    <footer className="app-footer">
      <div className="footer-wrapper">
        <div className="footer-content">
          <div className="footer-attributions">
            <div className="footer-weather-attribution">
              Weather data by <a href="https://open-meteo.com/" target="_blank" rel="noopener noreferrer" style={{color: '#7da7d9', textDecoration: 'none'}}>Open-Meteo.com</a>
            </div>
            <div className="footer-photos-attribution">
              Photos © <a href="https://sami-parks.fr" target="_blank" rel="noopener noreferrer" style={{color: '#7da7d9', textDecoration: 'none'}}>Sami Parks</a>
            </div>
            <div className="footer-lite-link">
              <a href="https://lite.magicparktimes.com" target="_blank" rel="noopener noreferrer" className="footer-link" title="Version optimisée pour connexions lentes">
                🚀 Version Lite
              </a>
            </div>
            <div className="footer-support-link">
              <Link to="/support-us" className="footer-link" title="Soutenez Magic Park Times">
                💝 Nous soutenir
              </Link>
            </div>
            <div className="footer-contact-link">
              <Link to="/contact" className="footer-link" title="Contactez-nous">
                Contact
              </Link>
            </div>
            <div className="footer-favorites">
              <span>Nos favoris:</span>
              <a href="https://parksmeets.com" target="_blank" rel="noopener noreferrer" className="footer-link">Parksmeet</a>
              <span>|</span>
              <a href="https://coasteractus.fr/" target="_blank" rel="noopener noreferrer" className="footer-link">Coasteractus</a>
              <span>|</span>
              <a href="https://www.dimensionparcs.fr/" target="_blank" rel="noopener noreferrer" className="footer-link">Dimension Parcs</a>
            </div>
          </div>
          <div className="footer-made-with">
            Built with 💖 by <a href="https://instagram.com/florent_kubrick" target="_blank" rel="noopener noreferrer" style={{color: '#7da7d9', textDecoration: 'none'}}>Florent Kubrick</a>
          </div>
          <span className="footer-copyright">
            © {new Date().getFullYear()} Magic Park Times
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
